export const TEST = 'Hello';

export const deploymentName = 'pephealthappprod';
export const envName = 'pephealth-prod';

export const domain = 'prod.au.pephealthapp.com';

// General App config
export const appToken = 'dc0e12';
export const appId = 1;
export const ubiquityCompanyId = 4;
// "prod-forpatientapp-staff" Cognito User Pool
export const userPoolId = 'ap-southeast-2_qNkg6Ut41';
export const userPoolAppClient = '4ki1gfi26mes56kt5221kjh2uc';

// IDM
export const idmOrganisation = 2;
export const organisationSlug = 'liquid-state';
export const idmApiRoot = `https://idm.${domain}/`;
export const organisationUrl = `${idmApiRoot}api/v1/organisations/`;
export const idmLogin = `https://idm.${domain}/api/login/`;
export const idmLogout = `https://idm.${domain}/logout/`;
// export const idmTokens = `https://idm.${domain}/api/tokens/`;

export const pepHealthApiRoot = `https://pephealth.${domain}/`;

// CMS apps
export const carbonURL = `https://carbon.${domain}`;
export const ubiquityURL = `https://ubiquity.${domain}`;

// UIS
export const uisApiRoot = `https://uis.${domain}/`;

// PIP
export const pipApiRoot = `https://pip.${domain}`;
export const pipAppUrl = `https://pip.${domain}/api/admin/v1/apps/`;

export const ubiquityApiRoot = `https://ubiquity.${domain}/`;
export const pathwaysApiRoot = `https://pathways.${domain}/v1/apps/{{app_ubiquity_token}}/`;

export const messagingApiRoot = `https://ubiquity.${domain}/api/core/v1/apps/`;

export const organisationDirectoryApiRoot = `https://directory.${domain}/api/v1/`;

export const videoCreationEndpoint = `https://unl5l2eu06.execute-api.ap-southeast-2.amazonaws.com/prod/create`;
export const videoExportStatusEndpoint = `https://unl5l2eu06.execute-api.ap-southeast-2.amazonaws.com/prod/export_status`;
export const videoTemplateNamePrefix = 'pep-health-video-';
export const videoCEDetails = {
  ce_space_uuid: '5760b022-ec47-4d10-8cd4-364b5eb7c200',
  ce_category_slug: 'uploaded-videos',
  template_name: 'pep-health-video-en',
};
export const videoUbiquityExportDetails = {
  theme_slug: 'default-theme',
  ubiquity_app_id: appId,
  ubiquity_company_id: ubiquityCompanyId,
  ubiquity_category_ids: ['2'],
};

export const mixpanelToken = 'eae6785522e45717e402a920e7882f81';
export const mixpanelOptions = {
  // disable_persistence: true
  // api_host: "https://api-eu.mixpanel.com",
};
export const analyticsHiddenSuperProperties = ['firstName', 'lastName', 'name'];

export const metricsUrlRoot = '';

export const documentTemplateUrl =
  'https://pephealthapp-prodassets.s3.ap-southeast-2.amazonaws.com/Document+Templates.zip';

export const FEATURES = {
  help: {
    url: 'https://liquidstate.atlassian.net/wiki/spaces/PDKB/overview',
  },
  // remove the display and tracking of Terms & Conditions and Privacy Policy (instead have short text for TCs and link to Privacy Policy doc)
  noTermsTrackingForDashboardUsers: false,
  appUsersControlledDocsForAllOrgs: false,
  showDataRequestsForHospitalUsers: false,
  evereg: false,
  pathwayLibrary: true,
  ucidIsRequired: false,
  ucidIsMod3736: false,
  externalVideoProviders: ['movingimage'],
  simplifiedPatientFiles: false,
};

export const envHasDataLake = true;
export const dataLakeBaseURL =
  'https://p4x0b6cksl.execute-api.ap-southeast-2.amazonaws.com/prod/admin_user_file_url';
export const dataLakeFormDataDownloadURL = `${dataLakeBaseURL}?application=form_submissions_csv&path=by_form/FORM_ID/all.csv`;
export const dataLakeFormDataDownloadForAppUserURL = `${dataLakeBaseURL}?application=form_submissions_csv&path=by_app_user/APP_USER_ID/FORM_ID.csv`;

export const restrictSharedSnapshotsCreation = false;

export const showAppUserHealthDataScreen = true;

export const kemtaiPatientURL = 'https://care-manage.kemtai.com/patients/KEMTAI_ID';

export const superUserCreatesManagedPathwayByDefault = false;
